<!-- INFO: Блок отображения сообщения, когда выбрали "Ответить" или "Редактировать" -->
<message-footer
  *ngIf="footerMessageOptions"
  [mode]="footerMessageOptions.mode"
  [message]="footerMessageOptions.message"
  (close)="onCloseFooterMessage($event)"
></message-footer>

<chat-input-box
  *ngIf="permissions?.canSendMessages"
  [chatId]="chatId"
  (textMessageSent)="textMessageSent.emit()"
></chat-input-box>
